import ManagementPageHTML, {
  IdentityCell,
  StatusBadge,
} from "../../components/ManagementPage/ManagementPageHTML";
import type { InventoryWareHouse } from "../../models/InventoryWareHouse";
import { InventoryWareHouseService } from "../../services/InventoryWareHouseService";
import { Status } from "../../models/Status";
import { useAuth } from "../../auth/useAuth";
import { useWarehouse } from "../../warehouse/WarehouseContext";
export default function WarehouseHTML() {
  const { hasPermission } = useAuth();
  const { Reload } = useWarehouse();
  const manage = hasPermission("Warehouse.Manage");
  return (
    <ManagementPageHTML<InventoryWareHouse>
      Title="Warehouses"
      Eyebrow="Inventory locations"
      Description="Manage warehouse names, addresses and contact numbers. Assign users to warehouses from the Users screen."
      AddLabel="Add warehouse"
      SearchPlaceholder="Search warehouse name or address"
      Service={InventoryWareHouseService()}
      Rows={[]}
      Summaries={[]}
      CanExport={false}
      CanCreate={manage}
      CanEdit={manage}
      CanDelete={manage}
      DefaultValues={{ Status: Status.Active }}
      GetRowKey={(x) => x.Code}
      GetSearchText={(x) => `${x.Code} ${x.Name} ${x.Address} ${x.PhoneNumber}`}
      GetStatus={(x) => x.Status}
      Statuses={Object.values(Status)}
      Columns={[
        {
          Key: "Name",
          Header: "Warehouse",
          Render: (x) => (
            <IdentityCell
              Icon="fa-warehouse"
              Title={x.Name}
              Subtitle={x.Code}
            />
          ),
        },
        { Key: "Address", Header: "Address", Render: (x) => x.Address },
        { Key: "PhoneNumber", Header: "Phone", Render: (x) => x.PhoneNumber },
        {
          Key: "Status",
          Header: "Status",
          Render: (x) => <StatusBadge Status={x.Status} />,
        },
      ]}
      DialogFields={[
        { Key: "Code", Label: "Warehouse code", Disable: true },
        { Key: "Name", Label: "Name", Required: true },
        { Key: "Address", Label: "Address", Type: "textarea", FullWidth: true },
        { Key: "PhoneNumber", Label: "Phone number", Type: "tel" },
        {
          Key: "Status",
          Label: "Status",
          Type: "select",
          Options: Object.values(Status),
          Required: true,
        },
      ]}
      OnSaved={() => Reload()}
    />
  );
}
